import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ExternalBranchJobEntity } from '../../domain/entities/ExternalBranchJobEntity'
import type { SyncExternalBranchJobAdminDto } from '@/backend/market'

export class ExternalBranchJobModel extends ExternalBranchJobEntity {
  constructor(dataDto: SyncExternalBranchJobAdminDto) {
    super()
    mapEntityProperties<ExternalBranchJobModel>(this, dataDto)
  }
}
